/**
 * Web stub for `react-native-nfc-manager`. NFC is not available in the
 * browser; every operation reports unsupported so the rest of the app
 * (which sees `nfcSupported = false`) renders the unavailable state.
 */

export const NfcEvents = {
  DiscoverTag: 'DiscoverTag',
  StateChanged: 'StateChanged',
  SessionClosed: 'SessionClosed',
} as const;

export const NfcTech = {
  Ndef: 'Ndef',
  NfcA: 'NfcA',
} as const;

export const Ndef = {
  encodeMessage: () => [] as number[],
  textRecord: () => ({}),
  uriRecord: () => ({}),
};

export type TagEvent = { id?: string; ndefMessage?: unknown[] };

const NfcManager = {
  isSupported: async () => false,
  isEnabled: async () => false,
  start: async () => undefined,
  stop: async () => undefined,
  requestTechnology: async () => null,
  cancelTechnologyRequest: async () => undefined,
  registerTagEvent: async () => undefined,
  unregisterTagEvent: async () => undefined,
  setEventListener: () => undefined,
  setAlertMessageIOS: () => undefined,
  getTag: async (): Promise<TagEvent | null> => null,
  ndefHandler: { writeNdefMessage: async () => undefined },
};

export default NfcManager;
